import axios from 'axios';

export const $instance = axios.create({
  baseURL: 'https://water-tracker-students.b.goit.study',
  // baseURL: 'http://localhost:3018',
});
